var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isVisible,
          expression: "isVisible"
        }
      ],
      ref: _vm.refDropdown,
      staticClass: "email-input-dropdown",
      class: _vm.dropdownClass,
      style: { minWidth: _vm.minWidth + "px" }
    },
    [
      _c(
        "div",
        {
          ref: "emailInputDropdownContent",
          staticClass: "email-input-dropdown__content"
        },
        [
          _c(
            "ul",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.loading,
                  expression: "!loading"
                }
              ],
              staticClass: "email-input-dropdown__content-options-container"
            },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "email-input-dropdown__content--loading" },
            [
              _vm.loading
                ? _c("CompassLoader", {
                    attrs: { color: "common-icon-neutral" }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }